import {
  Conversation,
  ConversationMessageStatus,
  RichTextConversationMessage,
} from '@stripe-internal/conversations-client';
import {FormattedMessage} from 'react-intl';
import {view} from '@sail/ui';
import {messages} from './messages';
import {TextRow} from '../../../Chat';
import {SelectOptionsMessage} from './SelectOptionsMessage';

type Props = {
  conversation: Conversation;
  message: RichTextConversationMessage;
  disableInteraction?: boolean;
};

export const TopicSelectorRowNext = ({
  conversation,
  message,
  disableInteraction,
}: Props) => {
  if (message.data.type !== 'select-options-conversation-message') {
    return null;
  }

  return (
    <view.div
      data-testid="topic-selector-row"
      css={{
        stack: 'y',
        gap: 'small',
        border: '1px solid',
        borderRadius: 'small',
        borderColor: 'border',
        padding: 'medium',
        backgroundColor: 'surface',
      }}
    >
      <view.h3 css={{font: 'heading.small', margin: '0'}}>
        <FormattedMessage {...messages.contactAnAgent} />
      </view.h3>
      <TextRow
        body={message.text}
        messageType={message.participant.role}
        error={
          message.status === ConversationMessageStatus.Error ? (
            <FormattedMessage {...messages.sendError} />
          ) : null
        }
      >
        <view.div css={{marginTop: 'space.75'}}>
          <SelectOptionsMessage
            conversation={conversation}
            message={message.data}
            disableInteraction={disableInteraction}
          />
        </view.div>
      </TextRow>
    </view.div>
  );
};
